import { render, staticRenderFns } from "./KnowledgeBase.vue?vue&type=template&id=2dc22248&scoped=true&"
import script from "./KnowledgeBase.vue?vue&type=script&lang=ts&"
export * from "./KnowledgeBase.vue?vue&type=script&lang=ts&"
import style0 from "./KnowledgeBase.vue?vue&type=style&index=0&id=2dc22248&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc22248",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VBtn,VCol,VDialog,VIcon,VImg,VPagination,VRow,VSkeletonLoader})
